<template>
    <div>
        <!-- Desktop/Tablet Layout -->
        <v-card
            v-if="!isMobile"
            class="mb-4 scrollable-card"
        >
            <v-card-title class="d-flex justify-space-between align-center">
                <span>{{ title }}</span>
                <div class="d-flex align-center">
                    <v-text-field
                        v-if="showSearch"
                        v-model="searchInput"
                        :label="t('search')"
                        hide-details
                        density="compact"
                        variant="outlined"
                        prepend-inner-icon="mdi-magnify"
                        class="mr-2"
                        style="max-width: 400px; min-width: 200px;"
                    />

                    <slot name="toolbar-actions" :items="items" :search="searchQuery" />
                </div>
            </v-card-title>

            <v-card-text>
                <v-skeleton-loader
                    v-if="!showTable"
                    type="table"
                    class="elevation-0"
                    :loading="!showTable"
                    :width="'100%'"
                    :height="'400px'"
                />

                <v-data-table-server
                    v-if="showTable"
                    v-bind="$attrs"
                    v-model:page="page"
                    v-model:items-per-page="itemsPerPage"
                    v-model:sort-by="sortBy"
                    :headers="computedHeaders"
                    :items="items"
                    :items-length="totalItems"
                    :loading="loading"
                    :search="searchQuery"
                    :items-per-page-options="itemsPerPageOptions"
                    :item-value="itemValue"
                    @update:options="loadItems"
                >
                    <template v-slot:item="{ item, columns }">
                        <slot name="desktop-row" :item="item" :columns="columns">
                            <tr>
                                <td v-for="column in columns" :key="column.key">
                                    <slot :name="`item.${column.key}`" :item="item" :value="getNestedValue(item, column.key)">
                                        {{ getNestedValue(item, column.key) }}
                                    </slot>
                                </td>
                            </tr>
                        </slot>
                    </template>

                    <!-- Pass through any additional slots -->
                    <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
                        <slot :name="slot" v-bind="scope" />
                    </template>
                </v-data-table-server>
            </v-card-text>
        </v-card>

        <!-- Mobile Layout -->
        <v-card
            v-if="isMobile"
            class="mb-4 scrollable-card"
        >
            <v-card-title class="d-flex justify-space-between align-center">
                <span>{{ title }}</span>
                <div class="d-flex align-center">
                    <v-text-field
                        v-if="showSearch"
                        v-model="searchInput"
                        :label="t('search')"
                        hide-details
                        density="compact"
                        variant="outlined"
                        prepend-inner-icon="mdi-magnify"
                        class="mr-2"
                        style="min-width: 110px;"
                    />

                    <slot name="mobile-toolbar-actions" :items="items" :search="searchQuery" />
                </div>
            </v-card-title>

            <v-card-text>
                <v-skeleton-loader
                    v-if="!showTable"
                    type="table"
                    class="elevation-0"
                    :loading="!showTable"
                    :width="'100%'"
                    :height="'400px'"
                />

                <v-data-table-server
                    v-if="isMobile && showTable"
                    v-bind="$attrs"
                    class="elevation-0 mobile-data-table"
                    :expand-on-click="false"
                    :locale="locale"
                    :no-data-text="t('noData')"
                    :items-per-page-text="t('itemsPerPage')"
                    v-model:page="page"
                    v-model:items-per-page="itemsPerPage"
                    v-model:sort-by="sortBy"
                    :headers="mobileHeaders"
                    :items="items"
                    :items-length="totalItems"
                    :loading="loading"
                    :search="searchQuery"
                    :items-per-page-options="itemsPerPageOptions"
                    :item-value="itemValue"
                    @update:options="loadItems"
                    :mobile="true"
                >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>
                                <slot name="mobile-item" :item="item">
                                    <v-card class="mb-2" variant="flat">
                                        <v-card-text>
                                            {{ JSON.stringify(item) }}
                                        </v-card-text>
                                    </v-card>
                                </slot>
                            </td>
                        </tr>
                    </template>
                </v-data-table-server>
            </v-card-text>
        </v-card>
    </div>
</template>

<script src="./model.js"></script>
<style src="./style.css"></style>
